import { Injectable } from '@angular/core';
import { Router } from '@angular/router'
import { Amplify, ResourcesConfig } from 'aws-amplify' // Import Amplify
import * as Auth from 'aws-amplify/auth'

@Injectable({
  providedIn: 'root'
})
export class CustomAuthService {
  constructor(private router: Router) {}

  public configure(config: ResourcesConfig): void {
    Amplify.configure(config)
  }

  public async getCurrentUser(): Promise<Auth.AuthUser> {
    const currentUser = await Auth.getCurrentUser()

    return currentUser
  }

  public async signIn(
    username: string,
    password: string,
  ): Promise<Auth.SignInOutput> {
    try {
      const user = await Auth.signIn({ username, password })
      const { nextStep } = user
      switch (nextStep.signInStep) {
        case 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP':
          break

        case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
          this.router.navigate(['verify-code'])
          break

        case 'DONE':
          break
      }

      return user
    } catch (error) {
      console.error('Error signing in:', error)
      this.getCurrentUser()
      throw error
    }
  }

  public async signOut(): Promise<void> {
    try {
      await Auth.signOut({ global: true })
    } catch (error) {
    }
  }

  async getAccessToken() {
    try {
      await Auth.getCurrentUser()
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && key.includes('accessToken')) {
          return localStorage.getItem(key)
        }
      }
      return null // Or handle appropriately if token is not found
    } catch (e) {
      console.error('Ocorreu um erro de autenticação.', e)
      return null
    }
  }

  // Method to get refresh token from local storage
  getRefreshToken(): string | null {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.includes('accessToken')) {
        return localStorage.getItem(key)
      }
    }
    return null // Or handle appropriately if token is not found
  }
  getIdToken(): string | null {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.includes('idToken')) {
        return localStorage.getItem(key)
      }
    }
    return null // Or handle appropriately if token is not found
  }

}
